import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.621 14A.62.62 0 0 1 2 13.379V2.622C2 2.278 2.278 2 2.621 2h2.758A.62.62 0 0 0 6 1.379V.622A.62.62 0 0 0 5.379 0H.621A.62.62 0 0 0 0 .622v14.757A.62.62 0 0 0 .621 16h14.758a.62.62 0 0 0 .621-.621v-4.758a.62.62 0 0 0-.621-.621h-.758a.62.62 0 0 0-.621.621v2.758a.62.62 0 0 1-.621.621zM9 .622v.757c0 .343.278.621.621.621h.88c.553 0 .83.669.439 1.061l-3.5 3.5a.62.62 0 0 0 0 .878l1.121 1.122a.62.62 0 0 0 .879 0l3.5-3.5A.62.62 0 0 1 14 5.5v.879c0 .343.278.621.621.621h.758A.62.62 0 0 0 16 6.379V.622A.62.62 0 0 0 15.379 0H9.621A.62.62 0 0 0 9 .622"
    }, null, -1)
  ]))]))
}
export default { render: render }